import { render, staticRenderFns } from "./FrontpageHtmlVideo.vue?vue&type=template&id=56ffa7cc&"
import script from "./FrontpageHtmlVideo.vue?vue&type=script&lang=js&"
export * from "./FrontpageHtmlVideo.vue?vue&type=script&lang=js&"
import style0 from "./FrontpageHtmlVideo.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports